import {
    Box,
    Typography,
    Paper,
    Grid,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    CircularProgress,
    Alert
} from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { dashboardService } from 'api/dashboardService';
import { TrendingUp, LocalMall } from '@mui/icons-material';

export default function VendorSalesReport() {
    const {
        data: salesReport,
        isLoading,
        isError
    } = useQuery({
        queryKey: ['vendorSalesReport'],
        queryFn: () => dashboardService.getSalesReport()
    });

    if (isLoading)
        return (
            <Box p={5} display="flex" justifyContent="center">
                <CircularProgress />
            </Box>
        );
    if (isError || !salesReport)
        return (
            <Box p={5}>
                <Alert severity="error">Failed to load sales report</Alert>
            </Box>
        );

    const { summary, timeline } = salesReport;

    return (
        <Box p={3} sx={{ bgcolor: '#fbfbfb', minHeight: '100vh' }}>
            <Box mb={4}>
                <Typography variant="h4" fontWeight={900}>
                    My Sales Report
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    Detailed view of your store's sales performance
                </Typography>
            </Box>

            {/* Summary Cards */}
            <Grid container spacing={3} mb={4}>
                <Grid item xs={12} md={4}>
                    <Paper sx={{ p: 3, borderRadius: 3, display: 'flex', alignItems: 'center', gap: 2 }}>
                        <Box sx={{ p: 1.5, bgcolor: 'primary.light', borderRadius: 2, color: 'primary.main' }}>
                            <TrendingUp />
                        </Box>
                        <Box>
                            <Typography variant="caption" color="text.secondary" fontWeight={600}>
                                TOTAL REVENUE
                            </Typography>
                            <Typography variant="h5" fontWeight={800}>
                                ₦{(summary?.totalRevenue || 0).toLocaleString()}
                            </Typography>
                        </Box>
                    </Paper>
                </Grid>
                <Grid item xs={12} md={4}>
                    <Paper sx={{ p: 3, borderRadius: 3, display: 'flex', alignItems: 'center', gap: 2 }}>
                        <Box sx={{ p: 1.5, bgcolor: 'success.light', borderRadius: 2, color: 'success.main' }}>
                            <LocalMall />
                        </Box>
                        <Box>
                            <Typography variant="caption" color="text.secondary" fontWeight={600}>
                                TOTAL ORDERS
                            </Typography>
                            <Typography variant="h5" fontWeight={800}>
                                {summary?.totalOrders || 0}
                            </Typography>
                        </Box>
                    </Paper>
                </Grid>
            </Grid>

            {/* Recent Timeline */}
            <Paper sx={{ borderRadius: 3, overflow: 'hidden', mb: 4 }}>
                <Box p={2} sx={{ bgcolor: '#fafafa', borderBottom: '1px solid #eee' }}>
                    <Typography variant="h6" fontWeight={700}>
                        Sales Timeline
                    </Typography>
                </Box>
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Date</TableCell>
                                <TableCell>Orders</TableCell>
                                <TableCell>Revenue</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {timeline && timeline.length > 0 ? (
                                timeline.map((item, index) => (
                                    <TableRow key={index} hover>
                                        <TableCell>{item.date}</TableCell>
                                        <TableCell>{item.orders}</TableCell>
                                        <TableCell fontWeight={600}>₦{(item.gross || 0).toLocaleString()}</TableCell>
                                    </TableRow>
                                ))
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={3} align="center">
                                        No recent data
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>
        </Box>
    );
}
